export const translations = {
  en: {
    appTagline: 'Personal Finance',
    logoPlaceholder: 'LOGO',
    title: 'Kakeibo — Personal Finance',
    headerTitle: 'Kakeibo',
    headerSubtitle: 'Personal finance',
    headerPoweredBy: 'Powered by Icarosoft.com',
    signedInAs: 'Signed in as:',
    addTransaction: 'Add',
    addExpense: 'Add expense',
    addIncome: 'Add income',
    email: 'Email',
    password: 'Password',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    passwordChanged: 'Password changed',
    changePasswordFailed: 'Failed to change password',
    passwordsMismatch: 'Passwords do not match',
    enterCurrentPassword: 'Enter current password',
    incorrectCurrentPassword: 'Incorrect current password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signOut: 'Sign out',
    pleaseWait: 'Please wait...',
    error: 'Error',
    invalidEmail: 'Invalid email address',
    passwordMin4: 'Password must be at least 4 characters',
    loginFailed: 'Login failed',
    amount: 'Amount',
    category: 'Category',
    date: 'Date',
    today: 'Today',
    changeDate: 'Change date',
    selectDate: 'Select date',
    notes: 'Notes',
    save: 'Save',
    cancel: 'Cancel',
    quarterSummary: 'Quarter Summary',
    last3Months: 'Last 3 months',
    showCurrentMonth: 'Current month',
    showLast3Months: 'Last 3 months',
    income: 'Income',
    expense: 'Expense',
    total: 'Total',
    noTransactions: 'No transactions',
    delete: 'Delete',
    confirmDeleteTitle: 'Delete transaction?',
    confirmDeleteMessage: 'This action cannot be undone.',
    dashboardTab: 'Dashboard',
    transactionsTab: 'Transactions',
    manageCategories: 'Manage categories',
    addCategory: 'Add category',
    close: 'Close',
    edit: 'Edit',
    globalCategory: 'global',
    name: 'Name',
    type: 'Type',
    color: 'Color (hex)',
    selectCategory: 'Select category',
    choose: 'Choose',
    noCategories: 'No categories yet',
    signupFailed: 'Signup failed',
    userExists: 'User already exists',
    settings: 'Settings',
    profile: 'Profile',
    editProfile: 'Edit profile',
    phone: 'Phone',
    country: 'Country',
    city: 'City',
    avatarUrl: 'Avatar URL',
    profileSaved: 'Profile saved',
    invalidPhone: 'Invalid phone number',
    birthdate: 'Birthdate',
    birthdateOptional: 'Birthdate (optional)',
    phonePlaceholder: 'e.g. +1 555 555 5555',
    deleteAccount: 'Delete account',
    deleteAccountWarning: 'This immediately and permanently deletes your account and all your data, including transactions, categories, and saved devices.',
    deleteAccountConfirmTitle: 'Delete account?',
    deleteAccountConfirmMessage: 'This action is permanent and cannot be undone.',
    deleteAccountFinalTitle: 'Final confirmation',
    deleteAccountFinalMessage: 'Do you want to immediately and permanently delete your account now?',
    deleteAccountSuccess: 'Your account and data were deleted immediately.',
    deleteAccountFailed: 'Failed to delete account',
    deleteAccountModalBody: 'To continue, type the email of the account you want to permanently delete.',
    deleteAccountEmailHint: 'Account email',
    deleteAccountEmailLabel: 'Confirm email',
    deleteAccountEmailPlaceholder: 'Type your email to confirm',
    deleteAccountEmailMismatch: 'The email does not match this account.',
  },
  es: {
    appTagline: 'Finanzas Personales',
    logoPlaceholder: 'LOGO',
    title: 'Kakeibo — Finanzas Personales',
    headerTitle: 'Kakeibo',
    headerSubtitle: 'Finanzas personales',
    headerPoweredBy: 'Impulsado por Icarosoft.com',
    signedInAs: 'Conectado como:',
    addTransaction: 'Agregar',
    addExpense: 'Agregar gasto',
    addIncome: 'Agregar ingreso',
    email: 'Correo',
    password: 'Contraseña',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    passwordChanged: 'Contraseña cambiada',
    changePasswordFailed: 'Error al cambiar la contraseña',
    passwordsMismatch: 'Las contraseñas no coinciden',
    enterCurrentPassword: 'Ingresa la contraseña actual',
    incorrectCurrentPassword: 'Contraseña actual incorrecta',
    signIn: 'Iniciar sesión',
    signUp: 'Crear cuenta',
    signOut: 'Cerrar sesión',
    pleaseWait: 'Espera...',
    error: 'Error',
    invalidEmail: 'Correo inválido',
    passwordMin4: 'La contraseña debe tener al menos 4 caracteres',
    loginFailed: 'No se pudo iniciar sesión',
    amount: 'Monto',
    category: 'Categoría',
    date: 'Fecha',
    today: 'Hoy',
    changeDate: 'Cambiar fecha',
    selectDate: 'Seleccionar fecha',
    notes: 'Notas',
    save: 'Guardar',
    cancel: 'Cancelar',
    quarterSummary: 'Resumen Trimestral',
    last3Months: 'Últimos 3 meses',
    showCurrentMonth: 'Mes actual',
    showLast3Months: 'Últimos 3 meses',
    income: 'Ingresos',
    expense: 'Gastos',
    total: 'Total',
    noTransactions: 'Sin transacciones',
    delete: 'Eliminar',
    confirmDeleteTitle: '¿Eliminar transacción?',
    confirmDeleteMessage: 'Esta acción no se puede deshacer.',
    dashboardTab: 'Panel',
    transactionsTab: 'Transacciones',
    manageCategories: 'Administrar categorías',
    addCategory: 'Agregar categoría',
    close: 'Cerrar',
    edit: 'Editar',
    globalCategory: 'global',
    name: 'Nombre',
    type: 'Tipo',
    color: 'Color (hex)',
    selectCategory: 'Seleccionar categoría',
    choose: 'Elegir',
    noCategories: 'Aún no hay categorías',
    signupFailed: 'Error al crear la cuenta',
    userExists: 'El usuario ya existe',
    settings: 'Configuración',
    profile: 'Perfil',
    editProfile: 'Editar perfil',
    phone: 'Teléfono',
    country: 'País',
    city: 'Ciudad',
    avatarUrl: 'URL del avatar',
    profileSaved: 'Perfil guardado',
    invalidPhone: 'Número de teléfono inválido',
    birthdate: 'Fecha de nacimiento',
    birthdateOptional: 'Fecha de nacimiento (opcional)',
    phonePlaceholder: 'ej. +34 612 345 678',
    deleteAccount: 'Eliminar cuenta',
    deleteAccountWarning: 'Esto elimina de forma inmediata y permanente tu cuenta y todos tus datos, incluyendo transacciones, categorías y dispositivos guardados.',
    deleteAccountConfirmTitle: '¿Eliminar cuenta?',
    deleteAccountConfirmMessage: 'Esta acción es permanente y no se puede deshacer.',
    deleteAccountFinalTitle: 'Confirmación final',
    deleteAccountFinalMessage: '¿Deseas eliminar tu cuenta de forma inmediata y permanente ahora?',
    deleteAccountSuccess: 'Tu cuenta y tus datos fueron eliminados de inmediato.',
    deleteAccountFailed: 'No se pudo eliminar la cuenta',
    deleteAccountModalBody: 'Para continuar, escribe el correo de la cuenta que quieres eliminar de forma permanente.',
    deleteAccountEmailHint: 'Correo de la cuenta',
    deleteAccountEmailLabel: 'Confirmar correo',
    deleteAccountEmailPlaceholder: 'Escribe tu correo para confirmar',
    deleteAccountEmailMismatch: 'El correo no coincide con esta cuenta.',
  }
};
